export const routes = {
    HOME: {
        name: "Home",
        path: "/",
    },
    LOGIN: {
        name: "Login",
        path: "/login"
    },
    DASHBOARD: {
        name: "Dashboard",
        path: "/dashboard"
    },
    ADDPOST: {
        name: 'AddPost',
        path: "/post"
    },
    EDITPOST: {
        name: 'AddPost',
        path: "/post/:id"
    },
    DETAILPOST: {
        name: 'DetailPost',
        path: "/postdetail/:id"
    }
};
